export { TemplateSettings } from "./TemplateSettings";



// WEBPACK FOOTER //
// ./src/pages/director/template-editor/components/template-settings/index.ts